<template>
  <div class="cat-picture">
    <img class="image" :src="imageUrl">
  </div>
</template>

<script>
import { mapState } from 'vuex';
import findWorkingUrl from '@/utils/imageLoader';

export default {
  data() {
    return {
      imageUrl: '',
    };
  },
  computed: {
    ...mapState(['cats']),
  },
  mounted() {
    this.updateImage();
  },
  watch: {
    cats() {
      this.updateImage();
    },
  },
  methods: {
    async updateImage() {
      this.imageUrl = await findWorkingUrl(this.cats.images);
    },
  },
};
</script>

<style scoped>
.cat-picture {
  text-align: center;
}
.image {
  max-width: 90%;
  max-height: 90%;
  min-width: 100px;
  min-height: 100px;
  background-color: #333333;
  border-radius: 20px;
}
</style>
